import { MeasureText } from "./MeasureText";
import { SetCtxFont } from "./SetCtxFont";
import { Globals } from "../CoreApp/Globals";

export function doMeasureTextHeight(fontString, fontSize, sample) {
  var width = MeasureText(sample, fontString);
  var ctx = Globals._measureBuffer.getContext("2d", { willReadFrequently: true });
  SetCtxFont(ctx, fontString);
  ctx.textBaseline = "top";
  ctx.textAlign = "left";
  var height = fontSize + 60;

  ctx.fillStyle = "#000000";
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = "#FFFFFF";
  ctx.fillText(sample, 0, 0);
  var imageData = ctx.getImageData(0, 0, width, height);

  var first;
  var last;
  var r = 0;
  var done = false;
  var d;

  //find the top
  while (!done) {
    for (var c = 0; c < width; c++) {
      d = imageData.data[r * width * 4 + c * 4];
      if (d != 0) {
        first = r;
        done = true;
        break;
      }
    }
    r++;
    if (r == height) return 0;
  }
  //start at bottom and look up
  done = false;
  r = height - 1;
  while (!done) {
    for (var c = 0; c < width; c++) {
      d = imageData.data[r * width * 4 + c * 4];
      if (d != 0) {
        last = r;
        done = true;
        break;
      }
    }
    r--;
    if (r == first) return 0;
  }

  return last - first + 1;
}
